module.exports = __webpack_public_path__ + "media/assets/img/logo-a0669c788f832e13142564d54b7dab36.jpg";